import { useState } from 'react';
import { urlArquivoAparencia } from '../nucleo/fontes';
import { useSessao } from '../nucleo/sessao';
import { nomeEhDoProduto } from '@malgoos/shared';
import { AssinaturaMalgo, SimboloMalgo } from './assinatura';
import { TextoCortado } from './texto-cortado';

export { AssinaturaMalgo, SimboloMalgo };

/**
 * Fase 2 (W4, A4): marca do cliente no topo do menu. Nome exibido e logo de Configurações > Aparência; sem marca, o símbolo e o
 * nome do produto, como antes. A logo vem da rota cacheável pelo hash (PNG ou WebP, nunca `data:`); se falhar, volta o símbolo.
 *
 * Fase 2 (W14): `cabecalho` é o cabeçalho do celular (Shell, `lg:hidden`), com o tamanho que ele já tinha (símbolo de 24 px e
 * nome em seminegrito), cortando o nome longo sem rolagem horizontal.
 */
export function MarcaDoMenu({ compacto = false, cabecalho = false, pequena = false }: { compacto?: boolean; cabecalho?: boolean; pequena?: boolean } = {}) {
  const s = useSessao();
  const logo = s.aparencia?.marca_logo ?? null;
  const [falhou, setFalhou] = useState<string | null>(null);
  const nome = s.aparencia?.marca_nome || 'MalgoOS';
  const tamanho = cabecalho ? 'size-6' : 'size-7';
  // 03/11: sem marca do cliente, a assinatura oficial, em qualquer modo; o nome segue para o leitor de tela.
  if (!logo && nomeEhDoProduto(s.aparencia?.marca_nome)) {
    return (
      <>
        <span className="text-tinta-1">
          <AssinaturaMalgo compacto={compacto} className={pequena ? 'h-5' : cabecalho ? 'h-6' : 'h-7'} />
        </span>
        <span className="sr-only">{nome}</span>
      </>
    );
  }
  const classeNome = compacto ? 'sr-only' : cabecalho ? 'min-w-0 font-semibold' : 'min-w-0 text-lg font-semibold tracking-tight';
  return (
    <>
      {logo && falhou !== logo ? <img src={urlArquivoAparencia(logo)} alt="" className={`${tamanho} shrink-0 rounded-lg object-contain`} onError={() => setFalhou(logo)} /> : <SimboloMalgo className={`${tamanho} shrink-0`} />}
      <TextoCortado className={classeNome} data-marca={cabecalho ? 'cabecalho' : 'menu'}>
        {nome}
      </TextoCortado>
    </>
  );
}
